import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { costRouteDefinitions } from './CostRouteDefinitions';
import { generatePageWithTabsRoute } from './routeGenerator';

const CostRoutes: RouteObject = generatePageWithTabsRoute(
  'Explore cost drivers, trends, and variances',
  BASE.COST,
  NESTED_ROUTES.COST.ALL_UTILITIES,
  costRouteDefinitions,
);

export default CostRoutes;
